import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, TransitionGroup as _TransitionGroup, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "search-bar mb-16" }
const _hoisted_2 = {
  ref: "tags_container",
  class: "tags-container"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "tags__none-found" }, " No tags found ", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "tags__tag tags__tag--show-all" }
const _hoisted_8 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "search-bar__field a4-12",
        onClick: $setup.focusTagSearch
      }, [
        _withDirectives(_createElementVNode("input", {
          ref: "tag_search_input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.tags_filter.search_query) = $event)),
          class: "search__input search__input--fw-400",
          type: "text",
          placeholder: "Search for a tag",
          onInput: $setup.handleTagSearchInputChange
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelText, $setup.tags_filter.search_query]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, {
        name: "grid",
        tag: "ul",
        class: _normalizeClass(["tags tags--search tags--overflow-scroll", {
				'tags--loading': $setup.loading_tags,
				'tags--overflowing': $setup.tags_overflowing
			}])
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.non_active_tags, (tag) => {
            return (_openBlock(), _createElementBlock("li", {
              key: 'non-active-tag-' + tag.id,
              class: "tags__tag"
            }, [
              _createElementVNode("button", {
                onClick: $event => ($setup.handleSetActiveTag( tag ))
              }, _toDisplayString(tag.title), 9 /* TEXT, PROPS */, _hoisted_3)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (!$setup.loading_tags && ( !$setup.non_active_tags || $setup.non_active_tags.length === 0 ))
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, _hoisted_6))
            : _createCommentVNode("v-if", true),
          _withDirectives(_createElementVNode("li", _hoisted_7, [
            _createElementVNode("button", { onClick: $setup.showAllTags }, [
              _createTextVNode(" Show all "),
              ($setup.tags_filter.total_count)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("( " + _toDisplayString($setup.tags_filter.total_count) + " )", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, $setup.show_common_tags]
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"])
    ], 512 /* NEED_PATCH */),
    _createVNode(_TransitionGroup, {
      name: "grid",
      tag: "ul",
      class: "tags mt-8"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tags_filter.active, (tag, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: 'active-tag-' + tag.id,
            class: "tags__tag tags__tag--selected"
          }, [
            _createTextVNode(_toDisplayString(tag.title) + " ", 1 /* TEXT */),
            _createElementVNode("button", {
              class: "tags__remove-tag",
              onClick: $event => ($setup.handleRemoveActiveTag( index ))
            }, null, 8 /* PROPS */, _hoisted_8)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}